var App = App || {};

App.SecondaryNav = (() => {
    'use strict';

    const selectors = {
        nav: '.secondary-nav',
        item: '.secondary-nav__item--has-children',
        toggle: '[data-secondary-nav-toggle]',
        submenu: '.secondary-nav__submenu',
        open: 'secondary-nav__submenu--open',
        closing: 'secondary-nav__submenu--closing'
    };

    const init = () => {
        document.querySelectorAll(selectors.nav).forEach(nav => {
            if (nav.dataset.secondaryNavInitialized === 'true') {
                return;
            }

            nav.dataset.secondaryNavInitialized = 'true';
            createController(nav).init();
        });
    };

    const createController = (nav) => {
        const state = {
            currentItem: null
        };

        const handleNavClick = (event) => {
            const toggle = event.target.closest(selectors.toggle);

            if (!toggle || !nav.contains(toggle)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            const item = toggle.closest(selectors.item);
            if (!item) {
                return;
            }

            if (isOpen(item)) {
                closeItem(item);
                return;
            }

            openItem(item);
        };

        const handleNavKeyDown = (event) => {
            const toggle = event.target.closest(selectors.toggle);

            if (!toggle || !nav.contains(toggle)) {
                return;
            }

            const item = toggle.closest(selectors.item);
            if (!item) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                closeItem(item, { returnFocus: true });
                return;
            }

            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                if (isOpen(item)) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
                return;
            }

            if (event.key === 'ArrowDown') {
                event.preventDefault();
                if (!isOpen(item)) {
                    openItem(item);
                }

                focusFirstSubmenuLink(item);
            }
        };

        const handleDocumentClick = (event) => {
            if (!state.currentItem || nav.contains(event.target)) {
                return;
            }

            closeItem(state.currentItem);
        };

        const handleDocumentKeyDown = (event) => {
            if (event.key !== 'Escape' || !state.currentItem) {
                return;
            }

            closeItem(state.currentItem, { returnFocus: true });
        };

        const openItem = (item) => {
            const submenu = getSubmenu(item);
            const toggle = getToggle(item);

            if (!submenu || !toggle) {
                return;
            }

            if (state.currentItem && state.currentItem !== item) {
                closeItem(state.currentItem);
            }

            clearClosingAnimation(submenu);
            submenu.classList.remove(selectors.closing);
            submenu.classList.add(selectors.open);
            submenu.setAttribute('aria-hidden', 'false');
            toggle.setAttribute('aria-expanded', 'true');
            state.currentItem = item;
        };

        const closeItem = (item, { returnFocus = false } = {}) => {
            const submenu = getSubmenu(item);
            const toggle = getToggle(item);

            if (!submenu || !toggle) {
                return;
            }

            toggle.setAttribute('aria-expanded', 'false');

            if (state.currentItem === item) {
                state.currentItem = null;
            }

            clearClosingAnimation(submenu);
            submenu.classList.remove(selectors.open);
            submenu.classList.add(selectors.closing);

            const handleAnimationEnd = () => {
                submenu.classList.remove(selectors.closing);
                submenu.setAttribute('aria-hidden', 'true');

                if (returnFocus) {
                    toggle.focus();
                }
            };

            submenu._secondaryNavAnimationEndHandler = handleAnimationEnd;
            submenu.addEventListener('animationend', handleAnimationEnd, { once: true });
        };

        const clearClosingAnimation = (submenu) => {
            if (submenu._secondaryNavAnimationEndHandler) {
                submenu.removeEventListener('animationend', submenu._secondaryNavAnimationEndHandler);
                submenu._secondaryNavAnimationEndHandler = null;
            }
        };

        const focusFirstSubmenuLink = (item) => {
            const firstLink = getSubmenu(item)?.querySelector('a');

            if (firstLink) {
                firstLink.focus();
            }
        };

        const getSubmenu = (item) => item.querySelector(selectors.submenu);

        const getToggle = (item) => item.querySelector(selectors.toggle);

        const isOpen = (item) => item.querySelector(selectors.submenu)?.classList.contains(selectors.open) ?? false;

        const init = () => {
            nav.addEventListener('click', handleNavClick);
            nav.addEventListener('keydown', handleNavKeyDown);
            document.addEventListener('click', handleDocumentClick);
            document.addEventListener('keydown', handleDocumentKeyDown);
        };

        return {
            init
        };
    };

    return {
        init
    };
})();

document.addEventListener('DOMContentLoaded', () => {
    App.SecondaryNav.init();
});
